import { Route } from '@angular/router';
import { PublicComponent } from './public.component';

export const publicRoutes: Route[] = [
  {
    path: 'public',
    component: PublicComponent,
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      },
      {
        path: 'login',
        loadComponent: () =>
          import('./login/login.component').then(
            (m) => m.LoginComponent,
          ),
      },
      {
        path: 'login-failed',
        loadComponent: () =>
          import('./login-failed/login-failed.component').then(
            (m) => m.LoginFailedComponent,
          ),
      },
      {
        path: '**',
        redirectTo: 'login',
      },
    ],
  },
];

